module.exports = __webpack_public_path__ + "img/PAG310_R.5a6c5412.png";